import { Components } from '@mui/material/styles/components';
import { ControllerLinkColor } from '../../palette';

export const LinkComponent: Components = {
  MuiLink: {
    styleOverrides: {
      root: {
        color: String(ControllerLinkColor.DefaultFg),
        cursor: 'pointer',
        textDecoration: 'underline',
      },
      underlineNone: {
        color: String(ControllerLinkColor.MenuFg),
        cursor: 'pointer',
        textDecoration: 'none',
      },
    },
  },
};
